import { Box, Button, Checkbox, Divider, FormHelperText, Grid, Stack, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";
import React from "react";
import { SELECT_HOURS_LIST, SELECT_MINUTES_LIST, WEEKDAYS_SHORT } from "../util/constants";

const BaseScheduleDialog = (props) => {
  const renderHours = () => {
    return SELECT_HOURS_LIST.map((hour) => {
      return (
        <MenuItem key={hour} value={hour}>
          {hour}
        </MenuItem>
      );
    });
  };

  const renderMinutes = () => {
    return SELECT_MINUTES_LIST.map((minute) => {
      return (
        <MenuItem key={minute} value={minute}>
          {minute}
        </MenuItem>
      );
    });
  };

  return (
    <Grid
      sx={{
        width: "572px",
        display: "inline-block",
        backgroundColor: "secondary.swaWhite",
        border: `1px solid`,
        borderColor: "secondary.swaGray3",
        borderRadius: "5px",
      }}
      container
    >
      {!!props.baseScheduleErrors.fullScheduleError && (
        <Grid item xs={12}>
          <Alert severity="error">{props.baseScheduleErrors.fullScheduleError}</Alert>
        </Grid>
      )}
      <Grid item xs={12}>
        <Alert severity="info" sx={{ borderBottomLeftRadius: "0px", borderBottomRightRadius: "0px" }}>
          If base schedule is unknown, leave shift times blank.
        </Alert>
      </Grid>
      <Grid container sx={{ backgroundColor: "secondary.swaLightestBlue", padding: "10px" }}>
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              marginTop: "6px",
            }}
            onClick={props.handleApplyToAll}
          >
            Apply To All
          </Button>
        </Grid>
        <Grid item xs={5} sx={{ paddingLeft: "10px" }}>
          <Stack direction="row">
            <FormControl
              sx={{
                width: "80px",
                textAlign: "left",
              }}
              variant="standard"
            >
              <InputLabel>Hr</InputLabel>
              <Select
                label="Hr"
                onChange={(event) => props.handleApplyToAllStartHourChange(event.target.value)}
                value={props.applyToAllFilterData.start.hr}
              >
                <MenuItem value="" disabled>
                  <em>Hour</em>
                </MenuItem>
                {renderHours()}
              </Select>
            </FormControl>
            <Box m={1} sx={{ paddingTop: "11px" }}>
              :
            </Box>
            <FormControl
              sx={{
                width: "80px",
                textAlign: "left",
              }}
              variant="standard"
            >
              <InputLabel>Min</InputLabel>
              <Select
                label="Min"
                onChange={(event) => props.handleApplyToAllStartMinChange(event.target.value)}
                value={props.applyToAllFilterData.start.min}
              >
                <MenuItem value="" disabled>
                  <em>Minute</em>
                </MenuItem>
                {renderMinutes()}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
        <Grid item xs={4} sx={{ paddingLeft: "16px" }}>
          <Stack direction="row">
            <FormControl
              sx={{
                width: "80px",
                textAlign: "left",
              }}
              variant="standard"
            >
              <InputLabel>Hr</InputLabel>
              <Select
                label="Hr"
                onChange={(event) => props.handleApplyToAllEndHourChange(event.target.value)}
                value={props.applyToAllFilterData.end.hr}
              >
                <MenuItem value="" disabled>
                  <em>Hour</em>
                </MenuItem>
                {renderHours()}
              </Select>
            </FormControl>
            <Box m={1} sx={{ paddingTop: "11px" }}>
              :
            </Box>
            <FormControl
              sx={{
                width: "80px",
                textAlign: "left",
              }}
              variant="standard"
            >
              <InputLabel>Min</InputLabel>
              <Select
                label="Min"
                onChange={(event) => props.handleApplyToAllEndMinChange(event.target.value)}
                value={props.applyToAllFilterData.end.min}
              >
                <MenuItem value="" disabled>
                  <em>Minute</em>
                </MenuItem>
                {renderMinutes()}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      </Grid>
      <Grid container sx={{ height: "40px", backgroundColor: "secondary.swaGray2" }}>
        <Grid
          item
          xs={1}
          sx={{ fontWeight: "bold", fontSize: "16px", textAlign: "left", paddingLeft: "18px", paddingTop: "10px" }}
        >
          Off
        </Grid>
        <Grid
          item
          xs={2}
          sx={{ fontWeight: "bold", fontSize: "16px", textAlign: "left", paddingLeft: "40px", paddingTop: "10px" }}
        >
          Day
        </Grid>
        <Grid
          item
          xs={5}
          sx={{ fontWeight: "bold", fontSize: "16px", textAlign: "left", paddingLeft: "14px", paddingTop: "10px" }}
        >
          Start
        </Grid>
        <Grid
          item
          xs={4}
          sx={{ fontWeight: "bold", fontSize: "16px", textAlign: "left", paddingLeft: "12px", paddingTop: "10px" }}
        >
          End
        </Grid>
      </Grid>

      {WEEKDAYS_SHORT.map((day) => {
        return (
          <>
            <Grid container key={day} sx={{ padding: "10px" }}>
              <Grid item xs={1}>
                <Checkbox
                  sx={{ paddingLeft: "6px", paddingTop: "14px" }}
                  onChange={(event) => {
                    props.handleCheckedShiftOff(event, day);
                  }}
                  checked={props.baseSchedule[day].isNA ? false : props.baseSchedule[day].isOFF}
                  disabled={props.baseSchedule[day].isNA}
                />
              </Grid>

              <Grid item xs={2}>
                <Typography variant="subtitle1" sx={{ paddingTop: "12px" }}>
                  {day.charAt(0).toUpperCase() + day.slice(1).toLowerCase()}
                </Typography>
              </Grid>

              <Grid item xs={5} sx={{ paddingLeft: "10px" }}>
                <Stack direction="row">
                  <FormControl
                    disabled={props.baseSchedule[day].isOFF || props.baseSchedule[day].isNA}
                    sx={{
                      width: "80px",
                      textAlign: "left",
                    }}
                    variant="standard"
                    error={
                      !!props.baseScheduleErrors[day].error ||
                      (!!props.baseScheduleErrors.fullScheduleError && !props.baseSchedule[day].isNA)
                    }
                  >
                    <InputLabel>Hr</InputLabel>
                    <Select
                      label="Hr"
                      onChange={(event) => props.handleStartHourChange(day, event.target.value)}
                      value={props.baseSchedule[day].start.hr}
                      renderValue={() =>
                        props.baseSchedule[day].isNA
                          ? "N/A"
                          : props.baseSchedule[day].isOFF
                          ? "OFF"
                          : props.baseSchedule[day].start.hr
                      }
                    >
                      <MenuItem value="" disabled>
                        <em>Hour</em>
                      </MenuItem>
                      {renderHours()}
                      <MenuItem value="OFF" disabled hidden={true} />
                      <MenuItem value="N/A" disabled hidden={true} />
                    </Select>
                  </FormControl>
                  <Box m={1} sx={{ paddingTop: "11px" }}>
                    :
                  </Box>
                  <FormControl
                    disabled={props.baseSchedule[day].isOFF || props.baseSchedule[day].isNA}
                    sx={{
                      width: "80px",
                      textAlign: "left",
                    }}
                    variant="standard"
                    error={
                      !!props.baseScheduleErrors[day].error ||
                      (!!props.baseScheduleErrors.fullScheduleError && !props.baseSchedule[day].isNA)
                    }
                  >
                    <InputLabel>Min</InputLabel>
                    <Select
                      label="Min"
                      onChange={(event) => props.handleStartMinChange(day, event.target.value)}
                      value={props.baseSchedule[day].start.min}
                      renderValue={() =>
                        props.baseSchedule[day].isNA
                          ? "N/A"
                          : props.baseSchedule[day].isOFF
                          ? "OFF"
                          : props.baseSchedule[day].start.min
                      }
                    >
                      <MenuItem value="" disabled>
                        <em>Minute</em>
                      </MenuItem>
                      {renderMinutes()}
                      <MenuItem value="OFF" disabled hidden={true} />
                      <MenuItem value="N/A" disabled hidden={true} />
                    </Select>
                  </FormControl>
                </Stack>
              </Grid>

              <Grid item xs={4} sx={{ paddingLeft: "16px" }}>
                <Stack direction="row">
                  <FormControl
                    disabled={props.baseSchedule[day].isOFF || props.baseSchedule[day].isNA}
                    sx={{
                      width: "80px",
                      textAlign: "left",
                    }}
                    variant="standard"
                    error={
                      !!props.baseScheduleErrors[day].error ||
                      (!!props.baseScheduleErrors.fullScheduleError && !props.baseSchedule[day].isNA)
                    }
                  >
                    <InputLabel>Hr</InputLabel>
                    <Select
                      label="Hr"
                      onChange={(event) => props.handleEndHourChange(day, event.target.value)}
                      value={props.baseSchedule[day].end.hr}
                      renderValue={() =>
                        props.baseSchedule[day].isNA
                          ? "N/A"
                          : props.baseSchedule[day].isOFF
                          ? "OFF"
                          : props.baseSchedule[day].end.hr
                      }
                    >
                      <MenuItem value="" disabled>
                        <em>Hour</em>
                      </MenuItem>
                      {renderHours()}
                      <MenuItem value="OFF" disabled hidden={true} />
                      <MenuItem value="N/A" disabled hidden={true} />
                    </Select>
                  </FormControl>
                  <Box m={1} sx={{ paddingTop: "11px" }}>
                    :
                  </Box>
                  <FormControl
                    disabled={props.baseSchedule[day].isOFF || props.baseSchedule[day].isNA}
                    sx={{
                      width: "80px",
                      textAlign: "left",
                    }}
                    variant="standard"
                    error={
                      !!props.baseScheduleErrors[day].error ||
                      (!!props.baseScheduleErrors.fullScheduleError && !props.baseSchedule[day].isNA)
                    }
                  >
                    <InputLabel>Min</InputLabel>
                    <Select
                      label="Min"
                      onChange={(event) => props.handleEndMinChange(day, event.target.value)}
                      value={props.baseSchedule[day].end.min}
                      renderValue={() =>
                        props.baseSchedule[day].isNA
                          ? "N/A"
                          : props.baseSchedule[day].isOFF
                          ? "OFF"
                          : props.baseSchedule[day].end.min
                      }
                    >
                      <MenuItem value="" disabled>
                        <em>Minute</em>
                      </MenuItem>
                      {renderMinutes()}
                      <MenuItem value="OFF" disabled hidden={true} />
                      <MenuItem value="N/A" disabled hidden={true} />
                    </Select>
                  </FormControl>
                </Stack>
              </Grid>
            </Grid>
            {props.baseScheduleErrors[day].error && (
              <FormHelperText error sx={{ textAlign: "center" }}>
                {props.baseScheduleErrors[day].error}
              </FormHelperText>
            )}
            <Divider />
          </>
        );
      })}
      <Grid>
        <Button
          onClick={props.handleClearBaseSchedule}
          variant="outlined"
          color="primary"
          sx={{ margin: "10px", float: "right" }}
        >
          Clear All
        </Button>
      </Grid>
    </Grid>
  );
};

BaseScheduleDialog.propTypes = {
  openBaseSchedule: PropTypes.bool.isRequired,
  baseSchedule: PropTypes.object.isRequired,
  baseScheduleErrors: PropTypes.object.isRequired,
  handleStartHourChange: PropTypes.func.isRequired,
  handleStartMinChange: PropTypes.func.isRequired,
  handleEndHourChange: PropTypes.func.isRequired,
  handleEndMinChange: PropTypes.func.isRequired,
  handleClearBaseSchedule: PropTypes.func.isRequired,
  handleCheckedShiftOff: PropTypes.func.isRequired,
  handleApplyToAll: PropTypes.func.isRequired,
  handleApplyToAllStartHourChange: PropTypes.func.isRequired,
  handleApplyToAllStartMinChange: PropTypes.func.isRequired,
  handleApplyToAllEndHourChange: PropTypes.func.isRequired,
  handleApplyToAllEndMinChange: PropTypes.func.isRequired,
  applyToAllFilterData: PropTypes.object.isRequired,
};

export default BaseScheduleDialog;
